























































import { Component, Vue } from 'vue-property-decorator'
import PhotoHeader from '@/components/organization/PhotoHeader.vue'
import Main from '@/components/organization/Main.vue'
import Comissao from '@/components/dialogs/Comissao.vue'
import {
  ComiteListOrganization,
  ComiteListCientific
} from '@/storage/programacao/comites'

@Component({
  components: {
    PhotoHeader,
    Main,
    Comissao
  }
})
export default class Organization extends Vue {
  private showComissao = false
  private comite = {}
  private organizacao = ComiteListOrganization
  private cientific = ComiteListCientific
  private showInfo(organizador: any) {
    if (organizador.participantes) {
      this.comite = organizador
      this.showComissao = true
    }
  }

  private hideComissao() {
    this.showComissao = false
  }
}
